import { styled } from "@mui/system";

export const CustomLabel = styled("label")`
  color: white;
  display: block;
`;
